module.exports = __webpack_public_path__ + "img/startse.189ad8f5.svg";